/**
 * Error message utility.
 *
 * EXT-7: the friendly-error helpers (getFriendlyError / getFriendlyActionError /
 * isNetworkError / FriendlyError / FRIENDLY_MESSAGES) were dropped because no
 * marketing surface consumed them after EXT-3. Only getErrorMessage survives,
 * consumed by src/components/ErrorFallback.tsx.
 */

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  if (error && typeof error === "object" && "message" in error) {
    return String((error as { message: unknown }).message);
  }
  return "An unexpected error occurred";
}
